<!-- Standalone header (no hamburger) -->
<header class="tp-header">
  <nav class="navbar container-fluid">
    <div class="brand">
      <a routerLink="/" class="brand-link">
        <img src="assets/images/Veeduplan logo.png" alt="VeeduPlan Logo" class="logo">
      </a>
    </div>
  </nav>
</header>

<!-- Page banner (base color) -->
<section class="template-banner">
  <div class="container banner-grid">
    <div>
      <h1 class="banner-title">Template Preview</h1>
      <p class="banner-subtitle">Preview and customize your selected template.</p>
    </div>
    <div class="banner-actions">
      <button class="back-button" type="button" routerLink="/viewalltemplate">
        ← Back
      </button>
      <button class="cart-button" type="button" (click)="goToCart()">
        🛒 Go to Cart <span class="badge">{{ cartCount }}</span>
      </button>
    </div>
  </div>
</section>

<section class="template-preview">
  <div class="container">

    <div class="preview-card" *ngIf="selectedProduct">
      <div class="image-wrap">
        <img [src]="selectedProduct.image" [alt]="selectedProduct.title">
      </div>
      <div class="info">
        <h2>{{ selectedProduct.title }}</h2>
        <p class="description">{{ selectedProduct.description }}</p>
        <div class="actions">
          <button class="primary" type="button" (click)="openDownload()">Download Now</button>
          <button class="secondary" type="button" (click)="toggleCart()">
            {{ inCart ? 'Remove from Cart' : 'Add to Cart' }}
          </button>
        </div>
      </div>
    </div>

    <div class="not-found" *ngIf="!selectedProduct">
      <p>Template not found.</p>
      <button class="secondary" routerLink="/viewalltemplate">Back to templates</button>
    </div>
  </div>
</section>

